import { gql } from '@apollo/client'

export const GET_TAGS = gql`
  query GetTags($parents: Boolean, $departmentId: ID) {
    currentUser {
      id
      profiles {
        id
        __typename
        category
        ... on OrganizerProfile {
          organizer {
            organizerId
          }
        }
      }
    }
    tags(parents: $parents, departmentId: $departmentId) {
      id
      category
      name
      color
      staffCount
      description
    }
  }
`
